import Joi from 'joi';
const alertActionButtonSchema = Joi.object({
    id: Joi.string()
        .max(100)
        .required(),
    label: Joi.string()
        .max(100)
        .required(),
    isDisabled: Joi.boolean().optional(),
    tooltip: Joi.string()
        .max(100)
        .optional(),
    type: Joi.string()
        .valid('primary', 'secondary', 'tertiary')
        .optional(),
}).unknown(false);
const showGlobalAlertToastEventPayloadSchema = Joi.object({
    alertMessage: Joi.string()
        .max(100)
        .required(),
    labelTranslation: Joi.string()
        .max(100)
        .optional(),
    showCloseButton: Joi.boolean().optional(),
    showCheckmarkIcon: Joi.boolean().optional(),
    autoHide: Joi.boolean().optional(),
    primaryActionButton: alertActionButtonSchema.optional(),
}).unknown(false);
export const validateShowGlobalAlertToastEventPayloadObject = (object) => {
    try {
        Joi.assert(object, showGlobalAlertToastEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
//# sourceMappingURL=utils.js.map